import React from 'react';
import './bannersSection.scss';
import BannersCardComponent from "./components/BannersCardComponent";

const BannersSection = () => {
	
	return (
		<div className="banners">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="banners__content">
				<div className="banners__content_data">
					<div className="stars"></div>
					<div className="stars2"></div>
					<div className="stars3"></div>
					<div className="banners__content_data_title">
						<h2>Banners</h2>
						<span>NFD Bot logos are displayed in the official colors and different chains</span>
					</div>
					<div className="banners__content_data_button">
						<button
							className="secondButton"
							onClick={() => {}}
						>
							<span>Download All Banners</span>
						</button>
					</div>
				</div>
				<div className="banners__content_items non-adaptive">
					<div className="banners__content_items_row first">
						<BannersCardComponent
							name={'banner 1'}
							banner={'XRP'}
						/>
						<BannersCardComponent
							name={'banner 2'}
							banner={'SUI'}
						/>
						<BannersCardComponent
							name={'banner 3'}
							banner={'TRON'}
						/>
						<BannersCardComponent
							name={'banner 4'}
							banner={'BERACHAIN'}
						/>
					</div>
					<div className="banners__content_items_row second">
						<BannersCardComponent
							name={'banner 5'}
							banner={'BNBChain'}
						/>
						<BannersCardComponent
							name={'banner 6'}
							banner={'Base'}
						/>
						<BannersCardComponent
							name={'banner 7'}
							banner={'ApeCoin'}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BannersSection;